import { TableColumn } from '../../../../types'
import dayjs from 'dayjs'
import { TableActions } from '../../../../components/Table/TableActions'

export const analyticsColumns = <T,>(): TableColumn[] => [
  { id: 'name', label: 'Name', width: 100 },
  {
    id: 'last_entry',
    label: 'Last Entry',
    width: 150,
    format: (value) =>
      dayjs(value).isValid() ? `${dayjs(value).format('DD.MM.YYYY')}` : value,
  },
  {
    id: 'total_entries',
    label: 'Total Entries',
    width: 180,
  },
  {
    id: 'consistent',
    label: 'Consistent',
    width: 180,
  },
  {
    id: 'inconsistent',
    label: 'Inconsistent',
    width: 180,
  },
  {
    id: 'creation_date',
    label: 'Created',
    width: 120,
    format: (value) =>
      dayjs(value).isValid() ? `${dayjs(value).format('DD.MM.YYYY')}` : value,
  },
  {
    id: 'created_by',
    label: 'Created by',
    width: 120,
  },
]
